module.exports = __webpack_public_path__ + "img/RareCyte_Header_Logo.acc09558.png";